import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { keys } from "./constants";

export const useInvalidateClientPrimaryContactPreferences = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: keys.primaryContactPreferencesDetail(),
      }),
    [queryClient],
  );
};
